"use strict";

var _taggedTemplateLiteral = require("/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const styled_components_1 = __importDefault(require("styled-components"));
/**
 * A SizedBox can be used to provide a component with a specifically sized
 * parent. Or it could be used as a spacer component, to prevent the need for
 * margins on other components.
 *
 * NB: This component is inspired by, but not identical to the Flutter
 * equivalent.
 * @see https://api.flutter.dev/flutter/widgets/SizedBox-class.html
 */


const SizedBox = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  flex-shrink: 0;\n"])), props => typeof props.width === 'number' ? "".concat(props.width, "px") : props.width, props => typeof props.height === 'number' ? "".concat(props.height, "px") : props.height);
exports.default = SizedBox;